import React, {memo} from 'react'

type Option = {
    label: string
    value: string | number
}

type TestCheckboxProps = {
    article?: string
    value: Array<string | number>
    onChange: (val: Array<string | number>) => void
    options: Option[]
}

const TestCheckbox: React.FC<TestCheckboxProps> = memo(({value, onChange, options, article}) => {
    const toggle = (v: string | number) => {
        const isSelected = Array.isArray(value) && value.includes(v)
        const updated = isSelected ? value.filter((i) => i !== v) : [...value, v]
        onChange(updated)
    }

    return (
        <div className='testOptionGroup'>
            {options.map((opt) => {
                const selected = Array.isArray(value) && value.includes(opt.value)
                return (
                    <div
                        key={opt.value}
                        className={`testOptionItem ${
                            Array.isArray(value) && value.includes(opt.value) ? 'selected' : ''
                        }`}
                        onClick={() => toggle(opt.value)}
                    >
                        <div className='testOptionIcon checkbox'>
                            {selected && <div className='checkboxChecked' />}
                        </div>
                        <div>{opt.label}</div>
                    </div>
                )
            })}
        </div>
    )
})

export default TestCheckbox
